(() => {
  window.Express = window.Express || {};

  function mediaToImage(media, fallbackAlt, metadata = {}) {
    if (!media) return null;

    if (typeof media === 'string') {
      return media ? { url: media, alt: fallbackAlt || 'Preview', ...metadata } : null;
    }

    const url = media.url || media.previewUrl || media.src || media.thumbnailUrl || '';
    if (!url) return null;

    return {
      url,
      alt: media.alt || media.altText || fallbackAlt || 'Preview',
      ...metadata,
    };
  }

  function addImage(images, seenUrls, image) {
    if (!image || !image.url || seenUrls.has(image.url)) return;
    seenUrls.add(image.url);
    images.push(image);
  }

  function getOptionImageCandidates(option) {
    const previewMedia = Array.isArray(option?.previewMedia) ? option.previewMedia : [];
    const images = Array.isArray(option?.images) ? option.images : [];

    return [
      previewMedia[0],
      images[0],
      images[1],
      previewMedia[1],
      option?.image,
      option?.thumbnail,
    ];
  }

  function getOptionPreviewImages(option) {
    const images = [];
    const seenUrls = new Set();
    const fallbackAlt = option?.label || 'Preview';
    const metadata = {
      optionLabel: option?.label || '',
      groupLabel: option?.groupLabel || '',
      groupKey: option?.groupKey || '',
    };

    getOptionImageCandidates(option).forEach((media) => {
      addImage(images, seenUrls, mediaToImage(media, fallbackAlt, metadata));
    });

    return images;
  }

  function getPreviewOption(activeGroup, selections, selectedOptions) {
    const activeSelectionKeys = selections?.[activeGroup?.groupTypeKey] || [];
    const activeGroupOption = activeSelectionKeys
      .map((optionKey) => activeGroup?.options?.find((option) => option.key === optionKey))
      .find(Boolean);
    const selectedOptionWithPreview = (selectedOptions || [])[0];

    return activeGroupOption || selectedOptionWithPreview || null;
  }

  function getProductFallbackImage(config, metadata = {}) {
    const productTitle = config?.product?.title || config?.title || 'Preview';

    return mediaToImage(
      config?.product?.product_image || config?.previewMedia?.[0] || config?.product?.images?.[0],
      productTitle,
      metadata
    );
  }

  function getSelectedPreviewImages(config, selectedOptions) {
    const images = [];

    (selectedOptions || []).forEach((option) => {
      const optionImages = getOptionPreviewImages(option);
      if (optionImages.length) {
        images.push(optionImages[0]);
        return;
      }

      const fallbackImage = getProductFallbackImage(config, {
        optionLabel: option?.label || '',
        groupLabel: option?.groupLabel || '',
        groupKey: option?.groupKey || '',
      });

      if (fallbackImage) images.push(fallbackImage);
    });

    return images;
  }

  function getFallbackPreviewImages(config) {
    const images = [];
    const seenUrls = new Set();
    const productTitle = config?.product?.title || config?.title || 'Preview';

    (config?.previewMedia || []).forEach((media) => {
      addImage(images, seenUrls, mediaToImage(media, productTitle));
    });

    addImage(images, seenUrls, mediaToImage(config?.product?.product_image, productTitle));

    (config?.product?.images || []).forEach((image) => {
      addImage(images, seenUrls, mediaToImage(image, productTitle));
    });

    return images;
  }

  function getPreviewImages(config, selectedOptions) {
    const selectedImages = getSelectedPreviewImages(config, selectedOptions);
    return selectedImages.length ? selectedImages : getFallbackPreviewImages(config);
  }

  function normalizeIndex(index, images) {
    const imageCount = images?.length || 0;
    if (!imageCount) return 0;

    const numericIndex = Number(index) || 0;
    return Math.min(Math.max(numericIndex, 0), imageCount - 1);
  }

  function getGroupIndex(images, groupKey) {
    if (!groupKey) return -1;
    return (images || []).findIndex((image) => image.groupKey === groupKey);
  }

  function getNextIndex(index, images, direction) {
    const imageCount = images?.length || 0;
    if (imageCount <= 1) return 0;

    return (normalizeIndex(index, images) + direction + imageCount) % imageCount;
  }

  window.Express.productBuilderPreview = {
    getOptionPreviewImages,
    getPreviewOption,
    getPreviewImages,
    normalizeIndex,
    getGroupIndex,
    getNextIndex,
  };
})();
